module.exports = __webpack_public_path__ + "img/02.8585f559.png";